import damascus_university from "../assets/logos/damascus_university.jpeg";
import unrwa from "../assets/logos/unrwa.jpeg";
import vwn from "../assets/logos/vwn.png";
import zanobia from "../assets/logos/zanobia.png";
import motopp from "../assets/logos/motopp.jpeg";
import pwc from "../assets/logos/pwc.png";
import eyeonthefuturelogo from "../assets/logos/eyeonthefuturelogo.png"

const experiences = {
  english: [
    {
      position: "Company Owner / Manager",
      employmentType: "Full-time",
      company: "Eye On The Future",
      from: "Novermber 2024",
      until: "-",
      period: "-",
      location: "The Hague - The Netherlands",
      logo: eyeonthefuturelogo,
      keys: ["Software Development", "SCRUM"],
    },
    {
      position: "Software Developer / Full-Stack",
      employmentType: "Full-time",
      company: "PwC (Not recommended)",
      from: "June 2023",
      until: "June 2024",
      period: "1 year",
      location: "Amsterdam - The Netherlands",
      logo: pwc,
      keys: ["Software Development", "SCRUM"],
    },
    {
      position: "Software Development Trainee",
      employmentType: "Full-time",
      company: "Motopp (Not recommended)",
      from: "February 2022",
      until: "June 2022",
      period: "5 Months",
      location: "Amsterdam - The Netherlands",
      logo: motopp,
      keys: ["Software Development", "SCRUM"],
    },
    {
      position: "Integration Trainer",
      employmentType: "Full-time",
      company: "VluchtelingenWerk Nederland",
      from: "May 2016",
      until: "Jul 2017 ",
      period: "1 year & 3 months",
      location: "The Hague - The Netherlands",
      logo: vwn,
      keys: ["presentation", "teaching"],
    },
    {
      position: "Science Teacher",
      employmentType: "Full-time",
      company: "UNRWA - UN",
      from: "Sep 2009",
      until: "Oct 2014",
      period: "5 years & 2 months",
      location: "Damascus - Syria",
      logo: unrwa,
      keys: ["presentation", "teaching", "experimentation"],
    },
    {
      position: "Manager",
      employmentType: "Full-time",
      company: "UNRWA - UN",
      from: "Dec 2012",
      until: "Nov 2013",
      period: "1 year",
      location: "Damascus - Syria",
      logo: unrwa,
      keys: ["management", "planning", "safety", "analyzing"],
    },
    {
      position: "Lecturer in physics ",
      employmentType: "Full-time",
      company:
        "Damascus University - Faculty of mechanical and electrical engineering",
      from: "Aug 2007",
      until: "Jun 2009",
      period: "2 years",
      location: "Damascus - Syria",
      logo: damascus_university,
      keys: [
        "presentation",
        "teaching",
        "experimentation",
        "supervising",
        "research",
        "analyzing",
      ],
    },
    {
      position: "Production and development laboratories",
      employmentType: "Full-time",
      company: "Zanobia Ceramic Company ",
      from: "Aug 2007",
      until: "Oct 2008",
      period: "1 year",
      location: "Damascus - Syria",
      logo: zanobia,
      keys: [
        "management",
        "experimentation",
        "supervising",
        "physics",
        "research",
        "analyzing",
      ],
    },
    {
      position: "Physicist - Laboratory Technician",
      employmentType: "Full-time",
      company: "Zanobia Ceramic Company ",
      from: "Jul 2006",
      until: "Aug 2007",
      period: "1 year & 4 months",
      location: "Damascus - Syria",
      logo: zanobia,
      keys: [
        "experimentation",
        "supervising",
        "physics",
        "research",
        "analyzing",
      ],
    },
  ],
  arabic: [
    {
      position: "مالك و مدير شركة",
      employmentType: "دوام كامل",
      company: "عين على المستقبل",
      from: "November 2024",
      until: "-",
      period: "-",
      location: "لاهاي - هولندا",
      logo: eyeonthefuturelogo,
      keys: ["Software Development", "SCRUM"],
    },
    {
      position: "مطور تطبيقات مكدس كامل",
      employmentType: "دوام كامل",
      company: "PwC - تجربة سيئة",
      from: "June 2023",
      until: "June 2024",
      period: " سنة واحدة",
      location: "أمستردام - هولندا",
      logo: pwc,
      keys: ["Software Development", "SCRUM"],
    },
    {
      position: "متدرب برمجة تطبيقات ميندكس",
      employmentType: "دوام كامل",
      company: "Motopp - غير موصى بها",
      from: "February 2022",
      until: "June 2022",
      period: "خمسة أشهر",
      location: "أمستردام - هولندا",
      logo: vwn,
      keys: ["Software Development", "SCRUM"],
    },
    {
      position: "مدرب الإندماج",
      employmentType: "دوام كامل",
      company: "VluchtelingenWerk Nederland",
      from: "May 2016",
      until: "Jul 2017 ",
      period: "سنة وثلاثة أشهر",
      location: "لاهاي - هولندا",
      logo: motopp,
      keys: ["presentation", "teaching"],
    },
    {
      position: "مدرس مواد العلوم",
      employmentType: "دوام كامل",
      company: "منطمة الأنروا - سوريا",
      from: "Sep 2009",
      until: "Oct 2014",
      period: "خمسة سنوات وشهرين",
      location: "دمشق - سوريا",
      logo: unrwa,
      keys: ["presentation", "teaching", "experimentation"],
    },
    {
      position: "مدير مركز إيواء اللاجئين",
      employmentType: "دوام كامل",
      company: "منظمة الأنروا - سوريا",
      from: "Dec 2012",
      until: "Nov 2013",
      period: "سنة واحدة",
      location: "دمشق - سوريا",
      logo: unrwa,
      keys: ["management", "planning", "safety", "analyzing"],
    },
    {
      position: "محاضر في الفيزياء",
      employmentType: "دوام جزئي",
      company: "جامعة دمشق - كلية الهندسة الميكانيكية والكهربائية",
      from: "Aug 2007",
      until: "Jun 2009",
      period: "سنتان",
      location: "دمشق - سوريا",
      logo: damascus_university,
      keys: [
        "presentation",
        "teaching",
        "experimentation",
        "supervising",
        "research",
        "analyzing",
      ],
    },
    {
      position: "مخابر الإنتاج والتطوير",
      employmentType: "دوام كامل",
      company: "شركة زنوبيا للسيراميك",
      from: "Aug 2007",
      until: "Oct 2008",
      period: "سنة واحدة",
      location: "دمشق - سوريا",
      logo: zanobia,
      keys: [
        "management",
        "experimentation",
        "supervising",
        "physics",
        "research",
        "analyzing",
      ],
    },
    {
      position: "مخبري فيزيائي",
      employmentType: "دوام كامل",
      company: "شركة زنوبيا للسيراميك  ",
      from: "Jul 2006",
      until: "Aug 2007",
      period: "سنة و أربعة أشهر",
      logo: zanobia,
      location: "دمشق - سوريا",
      keys: [
        "experimentation",
        "supervising",
        "physics",
        "research",
        "analyzing",
      ],
    },
  ],
};

export default experiences;
